// // // // PatientListPage.js - Displays list of all registered patients
// // // import React, { useEffect, useState } from 'react';
// // // import axios from 'axios';
// // // import { API_PATH } from '../Constant/constants'; // Adjust path if needed
// // // import useAuth from '../config/useAuth';           // Ensure this hook returns { token }
// // // import { Link } from 'react-router-dom';

// // // const PatientListPage = () => {
// // //   const [patients, setPatients] = useState([]);
// // //   const { token } = useAuth(); // Get token from context

// // //   useEffect(() => {
// // //     const fetchPatients = async () => {
// // //       try {
// // //         const response = await axios.get(`${API_PATH}/patients`, {
// // //           headers: {
// // //             Authorization: `Bearer ${token}`,
// // //           },
// // //         });
// // //         setPatients(response.data);
// // //       } catch (error) {
// // //         console.error('Error fetching patients:', error);
// // //       }
// // //     };

// // //     if (token) {
// // //       fetchPatients();
// // //     }
// // //   }, [token]);

// // //   return (
// // //     <div className="container py-4 w-100 mw-100">
// // //       <h4>className="mb-4">Patient List</h4>
// // //       {patients.length === 0 ? (
// // //         <p>No patients found.</p>
// // //       ) : (
// // //         <div className="table-responsive">
// // //           <table className="table table-bordered table-striped">
// // //             <thead className="table-dark text-white">
// // //               <tr>
// // //                 <th>#</th>
// // //                 <th>Name</th>
// // //                 <th>Gender</th>
// // //                 <th>Date of Birth</th>
// // //                 <th>Contact Info</th>
// // //                 <th>Registered On</th>
// // //                 <th>Actions</th>
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {patients.map((patient, index) => (
// // //                 <tr key={index}>
// // //                   <td>{index + 1}</td>
// // //                   <td>{patient.firstName} {patient.lastName}</td>
// // //                   <td>{patient.gender}</td>
// // //                   <td>{patient.dateOfBirth}</td>
// // //                   <td>
// // //                     <ul className="list-unstyled mb-0">
// // //                       {patient.contacts?.map(contact => (
// // //                         <li key={contact.id}>{contact.type}: {contact.value}</li>
// // //                       ))}
// // //                     </ul>
// // //                   </td>
// // //                   <td>{new Date(patient.registrationDate).toLocaleString()}</td>
// // //                   <td>
// // //                      <Link
// // //                       to={`/doctor/home/patients/${patient.id}/prescriptions`}
// // //                       className="btn btn-sm btn-primary me-2"
// // //                     >
// // //                       Add Prescription
// // //                     </Link>
// // //                     <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-info">
// // //                       View History
// // //                     </Link>
// // //                   </td>
// // //                 </tr>
// // //               ))}
// // //             </tbody>
// // //           </table>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default PatientListPage;

// // import React, { useEffect, useState } from 'react';
// // import axios from 'axios';
// // import { API_PATH } from '../Constant/constants';
// // import useAuth from '../config/useAuth';
// // import { Link } from 'react-router-dom';
// // import { FaUserCircle } from 'react-icons/fa';

// // const PatientListPage = () => {
// //   const [patients, setPatients] = useState([]);
// //   const [view, setView] = useState('card'); // 'card' or 'table'
// //   const [search, setSearch] = useState('');
// //   const { token } = useAuth();

// //   useEffect(() => {
// //     const fetchPatients = async () => {
// //       try {
// //         const response = await axios.get(`${API_PATH}/patients`, {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //           },
// //         });
// //         setPatients(response.data);
// //       } catch (error) {
// //         console.error('Error fetching patients:', error);
// //       }
// //     };

// //     if (token) fetchPatients();
// //   }, [token]);

// //   const filteredPatients = patients.filter(
// //     (p) =>
// //       p.firstName.toLowerCase().includes(search.toLowerCase()) ||
// //       p.lastName.toLowerCase().includes(search.toLowerCase())
// //   );

// //   return (
// //     <div className="container py-4">
// //       <div className="d-flex justify-content-between align-items-center mb-4">
// //         <h4>Patient List</h4>
// //         <div>
// //           <input
// //             type="text"
// //             placeholder="Search by name..."
// //             value={search}
// //             onChange={(e) => setSearch(e.target.value)}
// //             className="form-control d-inline-block w-auto me-2"
// //           />
// //           <button className="btn btn-outline-primary me-2" onClick={() => setView('card')}>
// //             Card View
// //           </button>
// //           <button className="btn btn-outline-secondary" onClick={() => setView('table')}>
// //             Table View
// //           </button>
// //         </div>
// //       </div>

// //       {view === 'card' ? (
// //         <div className="row g-4">
// //           {filteredPatients.map((patient, index) => (
// //             <div className="col-md-4" key={index}>
// //               <div className="card shadow-sm border-0">
// //                 <div className="card-body text-center">
// //                   <FaUserCircle size={60} className="text-secondary mb-3" />
// //                   <h5>{patient.firstName} {patient.lastName}</h5>
// //                   <p className="mb-1 text-muted">Gender: {patient.gender}</p>
// //                   <p className="mb-1 text-muted">DOB: {patient.dateOfBirth}</p>
// //                   <p className="mb-1 text-muted">
// //                     Contacts: {patient.contacts?.map(c => `${c.type}: ${c.value}`).join(', ') || 'N/A'}
// //                   </p>
// //                   <div className="mt-2">
// //                     <Link to={`/doctor/home/patients/${patient.id}/prescriptions`} className="btn btn-sm btn-primary me-2">
// //                       Add Prescription
// //                     </Link>
// //                     <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-outline-info">
// //                       View History
// //                     </Link>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       ) : (
// //         <div className="table-responsive">
// //           <table className="table table-bordered table-striped">
// //             <thead className="table-dark">
// //               <tr>
// //                 <th>#</th>
// //                 <th>Name</th>
// //                 <th>Gender</th>
// //                 <th>Date of Birth</th>
// //                 <th>Contacts</th>
// //                 <th>Registered On</th>
// //                 <th>Actions</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {filteredPatients.map((patient, index) => (
// //                 <tr key={index}>
// //                   <td>{index + 1}</td>
// //                   <td>{patient.firstName} {patient.lastName}</td>
// //                   <td>{patient.gender}</td>
// //                   <td>{patient.dateOfBirth}</td>
// //                   <td>
// //                     <ul className="list-unstyled mb-0">
// //                       {patient.contacts?.map(contact => (
// //                         <li key={contact.id}>{contact.type}: {contact.value}</li>
// //                       )) || <li>N/A</li>}
// //                     </ul>
// //                   </td>
// //                   <td>{new Date(patient.registrationDate).toLocaleDateString()}</td>
// //                   <td>
// //                     <Link to={`/doctor/home/patients/${patient.id}/prescriptions`} className="btn btn-sm btn-primary me-2">
// //                       Add Prescription
// //                     </Link>
// //                     <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-info">
// //                       View History
// //                     </Link>
// //                   </td>
// //                 </tr>
// //               ))}
// //               {filteredPatients.length === 0 && (
// //                 <tr>
// //                   <td colSpan="7" className="text-center text-muted">No patients found</td>
// //                 </tr>
// //               )}
// //             </tbody>
// //           </table>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default PatientListPage;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth';
// import { Link } from 'react-router-dom';
// import { FaUserCircle } from 'react-icons/fa';
// import { Modal, Button } from 'react-bootstrap';
// import { CSVLink } from 'react-csv';
// import * as XLSX from 'xlsx';

// const PatientListPage = () => {
//   const [patients, setPatients] = useState([]);
//   const [view, setView] = useState('card');
//   const [search, setSearch] = useState('');
//   const [genderFilter, setGenderFilter] = useState('');
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 6;
//   const { token } = useAuth();

//   useEffect(() => {
//     const fetchPatients = async () => {
//       try {
//         const response = await axios.get(`${API_PATH}/patients`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         setPatients(response.data);
//       } catch (error) {
//         console.error('Error fetching patients:', error);
//       }
//     };

//     if (token) fetchPatients();
//   }, [token]);

//   const handleExportExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(patients);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Patients');
//     XLSX.writeFile(workbook, 'patients.xlsx');
//   };

//   const filteredPatients = patients.filter((p) => {
//     return (
//       (p.firstName.toLowerCase().includes(search.toLowerCase()) ||
//         p.lastName.toLowerCase().includes(search.toLowerCase())) &&
//       (genderFilter === '' || p.gender === genderFilter)
//     );
//   });

//   const paginatedPatients = filteredPatients.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const totalPages = Math.ceil(filteredPatients.length / itemsPerPage);

//   const handleShowDetails = (patient) => {
//     setSelectedPatient(patient);
//     setShowModal(true);
//   };

//   return (
//     <div className="container py-4">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h4>Patient List</h4>
//         <div>
//           <input
//             type="text"
//             placeholder="Search by name..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             className="form-control d-inline-block w-auto me-2"
//           />
//           <select
//             className="form-select d-inline-block w-auto me-2"
//             value={genderFilter}
//             onChange={(e) => setGenderFilter(e.target.value)}
//           >
//             <option value="">All Genders</option>
//             <option value="Male">Male</option>
//             <option value="Female">Female</option>
//             <option value="Other">Other</option>
//           </select>
//           <button className="btn btn-outline-primary me-2" onClick={() => setView('card')}>
//             Card View
//           </button>
//           <button className="btn btn-outline-secondary me-2" onClick={() => setView('table')}>
//             Table View
//           </button>
//           <CSVLink data={patients} filename="patients.csv" className="btn btn-success me-2">
//             Export CSV
//           </CSVLink>
//           <button className="btn btn-success" onClick={handleExportExcel}>Export Excel</button>
//         </div>
//       </div>

//       {view === 'card' ? (
//         <div className="row g-4">
//           {paginatedPatients.map((patient, index) => (
//             <div className="col-md-4" key={index}>
//               <div className="card shadow-sm border-0 bg-light">
//                 <div className="card-body text-center">
//                   <FaUserCircle size={60} className="text-secondary mb-3" />
//                   <h5>{patient.firstName} {patient.lastName}</h5>
//                   <p className="mb-1">Gender: {patient.gender}</p>
//                   <p className="mb-1">DOB: {patient.dateOfBirth}</p>
//                   <p className="mb-1">Contacts: {patient.contacts?.map(c => `${c.type}: ${c.value}`).join(', ') || 'N/A'}</p>
//                   <div className="mt-2">
//                     <button onClick={() => handleShowDetails(patient)} className="btn btn-sm btn-outline-dark me-2">Details</button>
//                     <Link to={`/doctor/home/patients/${patient.id}/prescriptions`} className="btn btn-sm btn-primary me-2">Add Prescription</Link>
//                     <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-outline-info">View History</Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="table-responsive">
//           <table className="table table-bordered table-striped">
//             <thead className="table-dark">
//               <tr>
//                 <th>#</th>
//                 <th>Name</th>
//                 <th>Gender</th>
//                 <th>Date of Birth</th>
//                 <th>Contacts</th>
//                 <th>Registered On</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedPatients.map((patient, index) => (
//                 <tr key={index}>
//                   <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                   <td>{patient.firstName} {patient.lastName}</td>
//                   <td>{patient.gender}</td>
//                   <td>{patient.dateOfBirth}</td>
//                   <td>
//                     <ul className="list-unstyled mb-0">
//                       {patient.contacts?.map(contact => (
//                         <li key={contact.id}>{contact.type}: {contact.value}</li>
//                       )) || <li>N/A</li>}
//                     </ul>
//                   </td>
//                   <td>{new Date(patient.registrationDate).toLocaleDateString()}</td>
//                   <td>
//                     <button onClick={() => handleShowDetails(patient)} className="btn btn-sm btn-outline-dark me-2">Details</button>
//                     <Link to={`/doctor/home/patients/${patient.id}/prescriptions`} className="btn btn-sm btn-primary me-2">Add Prescription</Link>
//                     <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-info">View History</Link>
//                      <button onClick={() => handleShowDetails(patient)} className="btn btn-danger btn-outline-dark me-2">Delete</button>
//                   </td>
//                 </tr>
//               ))}
//               {paginatedPatients.length === 0 && (
//                 <tr>
//                   <td colSpan="7" className="text-center text-muted">No patients found</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <div className="d-flex justify-content-center mt-4">
//         {Array.from({ length: totalPages }, (_, i) => (
//           <button
//             key={i + 1}
//             className={`btn btn-sm mx-1 ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
//             onClick={() => setCurrentPage(i + 1)}
//           >
//             {i + 1}
//           </button>
//         ))}
//       </div>

//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Patient Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedPatient && (
//             <>
//               <p><strong>Name:</strong> {selectedPatient.firstName} {selectedPatient.lastName}</p>
//               <p><strong>Gender:</strong> {selectedPatient.gender}</p>
//               <p><strong>DOB:</strong> {selectedPatient.dateOfBirth}</p>
//               <p><strong>Contacts:</strong></p>
//               <ul>
//                 {selectedPatient.contacts?.map(contact => (
//                   <li key={contact.id}>{contact.type}: {contact.value}</li>
//                 ))}
//               </ul>
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default PatientListPage;




import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';
import { Link } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { Modal, Button,Form } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';

const PatientListPage = () => {
  const [patients, setPatients] = useState([]);
  const [view, setView] = useState('card');
  const [search, setSearch] = useState('');
  const [genderFilter, setGenderFilter] = useState('');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [patientToDelete, setPatientToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const { token } = useAuth();

    const [showEditModal, setShowEditModal] = useState(false);
    const [editPatient, setEditPatient] = useState(null);

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const response = await axios.get(`${API_PATH}/patients`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setPatients(response.data);
      } catch (error) {
        console.error('Error fetching patients:', error);
      }
    };

    if (token) fetchPatients();
  }, [token]);

  const handleDeletePatient = async (patientId) => {
    try {
      await axios.delete(`${API_PATH}/patients/${patientId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPatients(patients.filter((patient) => patient.id !== patientId));
      setShowDeleteConfirm(false);
      setPatientToDelete(null);
    } catch (error) {
      console.error('Error deleting patient:', error);
    }
  };

  const handleShowDeleteConfirm = (patient) => {
    setPatientToDelete(patient);
    setShowDeleteConfirm(true);
  };

  

  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(patients);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Patients');
    XLSX.writeFile(workbook, 'patients.xlsx');
  };

  const filteredPatients = patients.filter((p) => {
    return (
      (p.firstName.toLowerCase().includes(search.toLowerCase()) ||
        p.lastName.toLowerCase().includes(search.toLowerCase())) &&
      (genderFilter === '' || p.gender === genderFilter)
    );
  });

  const paginatedPatients = filteredPatients.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredPatients.length / itemsPerPage);

  const handleShowDetails = (patient) => {
    setSelectedPatient(patient);
    setShowModal(true);
  };



    const handleShowEditModal = (patient) => {
    setEditPatient({ ...patient });
    setShowEditModal(true);
  };

  const handleEditPatientChange = (field, value) => {
    setEditPatient((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleContactChange = (index, field, value) => {
    setEditPatient((prev) => {
      const updatedContacts = [...prev.contacts];
      updatedContacts[index] = { ...updatedContacts[index], [field]: value };
      return { ...prev, contacts: updatedContacts };
    });
  };

  const handleAddContact = () => {
    setEditPatient((prev) => ({
      ...prev,
      contacts: [...prev.contacts, { id: 0, type: '', value: '' }],
    }));
  };

  const handleRemoveContact = (index) => {
    setEditPatient((prev) => ({
      ...prev,
      contacts: prev.contacts.filter((_, i) => i !== index),
    }));
  };

    const handleSaveEdit = async () => {
    try {
      await axios.patch(`${API_PATH}/patients/${editPatient.id}`, editPatient, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPatients((prev) =>
        prev.map((p) => (p.id === editPatient.id ? editPatient : p))
      );
      setShowEditModal(false);
      setEditPatient(null);
    } catch (error) {
      console.error('Error updating patient:', error);
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Patient List</h4>
        <div>
          <input
            type="text"
            placeholder="Search by name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="form-control d-inline-block w-auto me-2"
          />
          <select
            className="form-select d-inline-block w-auto me-2"
            value={genderFilter}
            onChange={(e) => setGenderFilter(e.target.value)}
          >
            <option value="">All Genders</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <button className="btn btn-outline-primary me-2" onClick={() => setView('card')}>
            Card View
          </button>
          <button className="btn btn-outline-secondary me-2" onClick={() => setView('table')}>
            Table View
          </button>
          <CSVLink data={patients} filename="patients.csv" className="btn btn-success me-2">
            Export CSV
          </CSVLink>
          <button className="btn btn-success" onClick={handleExportExcel}>Export Excel</button>
        </div>
      </div>

      {view === 'card' ? (
        <div className="row g-4" style={{overflowY:'auto', maxHeight:'70vh'}}>
          {paginatedPatients.map((patient, index) => (
            <div className="col-md-6 px-2 py-2" key={index}>
              <div className="card shadow border-0 ">
                <div className="card-body text-center p-1 shadow">
                  <FaUserCircle size={60} className="text-secondary mb-3 m-auto" />
                  <h5>{patient.firstName} {patient.lastName}</h5>
                  <p className="mb-1">Gender: {patient.gender}</p>
                  <p className="mb-1">DOB: {patient.dateOfBirth}</p>
                  <p className="mb-1">Contacts: {patient.contacts?.map(c => `${c.type}: ${c.value}`).join(', ') || 'N/A'}</p>
                  {/* <div className="mt-2 text-center gap-2">
                    <button onClick={() => handleShowDetails(patient)} className="btn btn-sm btn-outline-dark me-2 ">Details</button>
                    <Link to={`/doctor/home/patients/${patient.id}/prescriptions`} className="btn btn-sm btn-color me-2 gap-2">Add Prescription</Link>
                    <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-outline-info me-2">View History</Link>
                    <button
                      onClick={() => handleShowEditModal(patient)}
                      className="btn btn-sm btn-color me-1"
                    >
                      Edit
                    </button>
                    <button onClick={() => handleShowDeleteConfirm(patient)} className="btn btn-sm btn-danger ">Delete</button>
                  </div> */}
                  <div className="mt-2 d-flex justify-content-around w-100 flex-wrap mb-2 ">

  <button onClick={() => handleShowDetails(patient)} className="btn btn-sm btn-outline-dark text-bold">
    Details
  </button>
  <Link to={`/doctor/home/patients/${patient.id}/prescriptions`} className="btn btn-sm btn-color text-bold">
    Add Prescription
  </Link>
  <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-outline-info text-bold">
    View History
  </Link>
  <button onClick={() => handleShowEditModal(patient)} className="btn btn-sm btn-color text-bold">
    Edit
  </button>
  <button onClick={() => handleShowDeleteConfirm(patient)} className="btn btn-sm btn-danger text-bold">
    Delete
  </button>
</div>

                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="table-responsive shadow p-2">
          <table className=" table-bordered table-striped">
            <thead className="tableborder">
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Gender</th>
                <th>Date of Birth</th>
                <th>Contacts</th>
                <th>Registered On</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody >
              {paginatedPatients.map((patient, index) => (
                <tr key={index} className='datahover'>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{patient.firstName} {patient.lastName}</td>
                  <td>{patient.gender}</td>
                  <td>{patient.dateOfBirth}</td>
                  <td>
                    <ul className="list-unstyled mb-0">
                      {patient.contacts?.map(contact => (
                        <li key={contact.id}>{contact.type}: {contact.value}</li>
                      )) || <li>N/A</li>}
                    </ul>
                  </td>
                  <td>{new Date(patient.registrationDate).toLocaleDateString()}</td>
                  <td>
                    <button onClick={() => handleShowDetails(patient)} className="btn btn-sm btn-outline-dark me-2">Details</button>
                    <Link to={`/doctor/home/patients/${patient.id}/prescriptions`} className="btn btn-sm btn-color  me-2">Add Prescription</Link>
                    <Link to={`/doctor/home/patients/${patient.id}`} className="btn btn-sm btn-info me-2">View History</Link>
                      <button
                      onClick={() => handleShowEditModal(patient)}
                      className="btn btn-sm btn-color me-2"
                    >
                      Edit
                    </button>
                    <button onClick={() => handleShowDeleteConfirm(patient)} className="btn btn-sm btn-danger">Delete</button>
                  </td>
                </tr>
              ))}
              {paginatedPatients.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center text-muted">No patients found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <div className="d-flex justify-content-center mt-4">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            className={`btn btn-sm mx-1 ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Patient Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPatient && (
            <>
              <p><strong>Name:</strong> {selectedPatient.firstName} {selectedPatient.lastName}</p>
              <p><strong>Gender:</strong> {selectedPatient.gender}</p>
              <p><strong>DOB:</strong> {selectedPatient.dateOfBirth}</p>
              <p><strong>Contacts:</strong></p>
              <ul>
                {selectedPatient.contacts?.map(contact => (
                  <li key={contact.id}>{contact.type}: {contact.value}</li>
                ))}
              </ul>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteConfirm} onHide={() => setShowDeleteConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete {patientToDelete?.firstName} {patientToDelete?.lastName}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => handleDeletePatient(patientToDelete.id)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
              <Modal.Header closeButton>
                <Modal.Title>Edit Patient</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {editPatient && (
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        value={editPatient.firstName}
                        onChange={(e) => handleEditPatientChange('firstName', e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        value={editPatient.lastName}
                        onChange={(e) => handleEditPatientChange('lastName', e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Gender</Form.Label>
                      <Form.Select
                        value={editPatient.gender}
                        onChange={(e) => handleEditPatientChange('gender', e.target.value)}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        value={editPatient.dateOfBirth}
                        onChange={(e) => handleEditPatientChange('dateOfBirth', e.target.value)}
                      />
                    </Form.Group>
      
                    <hr />
                    <h5>Contacts</h5>
                    {editPatient.contacts?.map((contact, index) => (
                      <div key={index} className="d-flex align-items-center gap-2 mb-2">
                        <Form.Select
                          value={contact.type}
                          onChange={(e) => handleContactChange(index, 'type', e.target.value)}
                        >
                          <option value="">Select Type</option>
                          <option value="Phone">Phone</option>
                          <option value="Email">Email</option>
                          <option value="WhatsApp">WhatsApp</option>
                        </Form.Select>
                        <Form.Control
                          value={contact.value}
                          onChange={(e) => handleContactChange(index, 'value', e.target.value)}
                          placeholder="Enter value"
                        />
                        <Button
                          variant="danger"
                          onClick={() => handleRemoveContact(index)}
                          size="sm"
                        >
                          Remove
                        </Button>
                      </div>
                    ))}
                    <Button variant="secondary" onClick={handleAddContact}>
                      Add Contact
                    </Button>
                  </Form>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSaveEdit}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </Modal>





    </div>
  );
};

export default PatientListPage;


